import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    "data-testid": "modal-title",
    class: "text-xl font-semibold text-gray-900 dark:text-white"
};
const _hoisted_2 = { class: "space-y-4" };
const _hoisted_3 = { class: "text-base leading-relaxed text-gray-500 dark:text-gray-400" };
const _hoisted_4 = { class: "p-4 bg-gray-50 rounded-lg dark:bg-gray-800" };
const _hoisted_5 = { class: "space-y-2" };
const _hoisted_6 = { class: "flex justify-between" };
const _hoisted_7 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_8 = { class: "text-sm font-semibold text-gray-900 dark:text-white" };
const _hoisted_9 = { class: "flex justify-between" };
const _hoisted_10 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_11 = { class: "text-sm font-semibold text-green-600 dark:text-green-400" };
const _hoisted_12 = { class: "text-sm text-gray-500 dark:text-gray-400" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useSubscriptionUtils } from "@/shared/composables/useSubscriptionUtils";
import { Modal, Button, Alert } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CancelNextTransactionModal',
    props: {
        isOpen: { type: Boolean },
        subscriptionId: {},
        shopperReference: {},
        merchantReference: {},
        nextTransactionDate: {},
        isLoading: { type: Boolean, default: false }
    },
    emits: ["close", "confirm"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const { formatDate } = useSubscriptionUtils();
        const isModalOpen = computed({
            get: () => props.isOpen,
            set: () => handleClose(),
        });
        const formattedNextDate = computed(() => {
            return formatDate(props.nextTransactionDate);
        });
        const handleClose = () => {
            if (!props.isLoading) {
                emit("close");
            }
        };
        const handleConfirm = () => {
            if (!props.isLoading) {
                emit("confirm");
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isModalOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isModalOpen).value = $event)),
                size: "sm",
                "data-testid": "cancel-next-payment-modal",
                dismissable: false,
                "close-on-escape": !__props.isLoading,
                onClose: handleClose
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancelNext.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('dashboard.subscriptions.modal.buttons.cancel'),
                        disabled: __props.isLoading,
                        "data-testid": "cancel-modal-btn",
                        onClick: handleClose
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    _createVNode(_unref(Button), {
                        variant: "error",
                        label: _unref(t)('dashboard.subscriptions.modal.cancelNext.confirmButton'),
                        loading: __props.isLoading,
                        "data-testid": "submit-skip-next-btn",
                        onClick: handleConfirm
                    }, null, 8 /* PROPS */, ["label", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(Alert), {
                            color: "info",
                            heading: _unref(t)('dashboard.subscriptions.modal.cancelNext.info.title'),
                            message: _unref(t)('dashboard.subscriptions.modal.cancelNext.info.message')
                        }, null, 8 /* PROPS */, ["heading", "message"]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancelNext.description", {
                            merchantReference: props.merchantReference,
                        })), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("dl", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("dt", _hoisted_7, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancelNext.currentNextDate")), 1 /* TEXT */),
                                    _createElementVNode("dd", _hoisted_8, _toDisplayString(formattedNextDate.value), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("dt", _hoisted_10, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancelNext.subscriptionStatus")), 1 /* TEXT */),
                                    _createElementVNode("dd", _hoisted_11, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancelNext.remainsActive")), 1 /* TEXT */)
                                ])
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("dashboard.subscriptions.modal.cancelNext.consequence")), 1 /* TEXT */)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "close-on-escape"]));
        };
    }
});
